/*************************************************/
/* MODAL                                         */
/*************************************************/

export function modal($body, bodyLoadingClass) {
    let $modal,
        $modalDialog,
        $modalContent,
        $modalCloseButton,
        $playVideoTrigger,
        $playBannerVideoTrigger,
        modalContentPadding,
        utils;

    const init = function () {
        $modal = $(".modal"),
            $modalDialog = $(".modal-dialog"),
            $modalContent = $(".modal-content"),
            $modalCloseButton = $(".modal-close"),
            $playVideoTrigger = $(".video-item__player"),
            $playBannerVideoTrigger = $('.banner__video--play-button'),
            modalContentPadding = $modalContent.css('padding-top');

        modalUtils();


        const insertYoutubeApiScriptTag = function () {
            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }


        const playVideo = function ($this) {
            const targetModalId = $this.attr("data-target");
            let videoSrc = $this.attr('data-video-src');
            let isYoutubeVideo = false;

            if (videoSrc.length <= 0) {
                videoSrc = $this.attr('data-video-id');
                if (!$this.hasClass('video-item__player--no-cookie') && !CookieInformation.getConsentGivenFor('cookie_cat_marketing')) {
                    CookieConsent.renew();
                    return false;
                } else if (!$this.hasClass('video-item__player--no-cookie')) {
                    insertYoutubeApiScriptTag();
                    isYoutubeVideo = true;
                }
            }

            if (videoSrc && targetModalId) {
                if (isYoutubeVideo) {
                    utils.Video.PlayYoutubeVideoInModal(targetModalId, videoSrc);
                } else {
                    utils.Video.PlayLocalVideoInModal(targetModalId, videoSrc);
                }
            } else {
                console.error("Video not found");
            }
        }


        if ($playVideoTrigger.length > 0) {
            $playVideoTrigger.each(function () {
                const $this = $(this);

                $this.on('click', function (e) {
                    e.preventDefault();
                    playVideo($this);
                });
            });
        }

        if ($playBannerVideoTrigger.length > 0) {
            $playBannerVideoTrigger.each(function () {
                const $this = $(this);

                $this.on('click', function (e) {
                    e.preventDefault();
                    playVideo($this);
                });
            });
        }

        $modalCloseButton.on('click', utils.Modal.CloseModal);

        //Close if background is clicked, but not if modalDialog is clicked
        $modal.on('click', utils.Modal.CloseModal);
        $modalDialog.on('click', function (e) {
            e.stopPropagation();
        });
    };

    function modalUtils() {
        if (!utils) {
            utils = {};
        }

        if ($modal.length > 0) {
            utils.Modal = {
                OpenModal(modalId, content) {
                    const _modal = $(modalId);
                    $body.addClass("noscroll");
                    _modal.addClass("modal--show");
                    _modal.find($modalContent).html(content);
                },
                CloseModal(clearContent = true) {
                    $modal.removeClass("modal--show");
                    if (clearContent = true) {
                        $modalContent.css('padding-top', modalContentPadding);
                        $modalContent.html("");
                    }
                    $body.removeClass(bodyLoadingClass);
                    $body.removeClass("noscroll");
                }
            };
        }

        utils.Video = {
            PlayYoutubeVideoInModal(modalId, videoId) {
                let playerId = "modalplayer";
                let player = document.createElement("div");
                player.id = playerId;
                utils.Modal.OpenModal(modalId, player);
                $body.addClass(bodyLoadingClass);
                var iterations = 0;

                var loadViewTimer = setInterval(function () {
                    if (youtubeLoaded) {
                        clearInterval(loadViewTimer);
                        var ytplayer = new YT.Player(playerId,
                            {
                                height: "100%",
                                width: "100%",
                                videoId: videoId,
                                host: "https://www.youtube-nocookie.com",
                                events: {
                                    "onReady": onPlayerReady,
                                    "onStateChange": onPlayerStateChange
                                },
                                playerVars: {
                                    showinfo: 0,
                                    rel: 0
                                }
                            });
                    } else {
                        iterations++;
                    }

                    //Lets try for 10 seconds
                    if (iterations === 100) {
                        clearInterval(loadViewTimer);
                        utils.Modal.CloseModal();
                    }

                }, 100);

                function onPlayerReady(event) {
                    $body.removeClass(bodyLoadingClass);
                    event.target.playVideo();
                }

                function onPlayerStateChange(event) {
                    if (event.data === YT.PlayerState.ENDED) {
                        ytplayer.destroy();
                        utils.Modal.CloseModal();
                    }
                }
            },
            PlayLocalVideoInModal(modalId, videoSrc) {
                let playerId = "modalplayer";
                let player = document.createElement("video");
                player.id = playerId;
                player.src = videoSrc;
                player.autoplay = true;
                player.controls = true;
                console.log($modalContent.css('padding-top'));
                $modalContent.css('padding-top', 0);
                utils.Modal.OpenModal(modalId, player);

                player.addEventListener('ended', function () {
                    utils.Modal.CloseModal();
                });
            }
        };
    }

    init();
}



// WEBPACK FOOTER //
// ./src/scripts/partials/modal.js